import React, { useState } from 'react'
import DebateTeam from './DebateTeam'
import DebateTimer from './DebateTimer'
import { BiDotsVerticalRounded } from "react-icons/bi"
import { useDispatch, useSelector } from 'react-redux'
import { deleteDebate } from '../../../redux/Thunks/debatesThunk'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { userInfo } from '../../../redux/Selectors/selectors'


const DebateRoom = ({debateDetails}) => {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const user = useSelector(state => userInfo(state))

  const [toggleMore, setToggleMore] = useState(false)

  const deleteDebateItem = async (id) => {
      const response = await dispatch(deleteDebate({debate_id : id, user_id : user?.id })).unwrap()

      if(response?.message){
        toast.success(response?.message)
        await new Promise(resolve => setTimeout(resolve, 1500))
        navigate("/dashboard")
      }else{
        toast.error("Ooops, something went wrong.")
      }

  }

  return (
     <>
   {debateDetails?.debate_id &&
   (

    <div
     onClick={() => {
      if(toggleMore){
        setToggleMore(false)
      }
        
     }}
     className={`bg-[#202020] relative  text-white w-full lg:w-2/3  rounded-lg`}>

        <div className='relative flex flex-col md:flex-row justify-between items-center p-4'>
      <div className='text-center my-3'>
      <h1 className='font-bold text-white text-xl lg:text-3xl md:p-5'>
              Welcome to the Debate Room!
            </h1>
      </div>

        <div className='flex justify-center md:mr-4'>
        <DebateTimer 
        finished={debateDetails?.finished}
        hasStarted={debateDetails?.has_started}
         />
        </div>

        {debateDetails?.author?.id === user?.id
        &&
        <div className='absolute right-3 top-3'>
          <button onClick={ () => setToggleMore(!toggleMore)}>
          <BiDotsVerticalRounded  className='text-white text-2xl'/>
          </button>
          {toggleMore && 
            <div className='flex flexcol justify-center items-center absolute top-5 right-4 z-[3]
           bg-white h-[40px] w-[120px] rounded-md text-black'>
              <button 
              onClick={() => deleteDebateItem(debateDetails?.debate_id)}
              className='transition-all ease-linear hover:translate-x-[5px] 
              w-full font-semibold text-red-600'>delete</button>
          </div>
          }

        </div>
        }




        </div>
        {debateDetails &&
            <div className='ml-5'>
            
              <div className='bg-[#202020] flex flex-col sm:justify-center py-5 px-2.5 sm:px-4'>

        <div className='flex justify-around flex-col sm:px-4 mt-5'>
        <h3 className='text-2xl font-bold text-center'>{debateDetails?.topic}</h3>
          <p className='font-medium text-sm my-2.5'>Created by: {debateDetails?.author?.username}</p>
          <p className='my-7 px-2.5'>{debateDetails?.description}</p>
        </div>


                    <div className='flex justify-between sm:justify-center my-5'>
              <DebateTeam debaters={debateDetails?.supporting} stance="Supporting" />
              <div className='flex justify-center items-center mx-3 md:mx-8  md:h-[270px]' >
                      <h3 className='text-[18px] sm:text-2xl font-bold'>Vs</h3>
              </div> 
              <DebateTeam debaters={debateDetails?.opposing} stance="Opposing" />
                    </div>

            
              </div>
              </div>
        }

    </div>
   )}
     </>
  )
}

export default DebateRoom